<form [formGroup]="fG">
  <ejs-dropdownlist
    #dropdownRef
    [formControlName]="fCN"
    [width]="width"
    [popupWidth]="popupWidth"
    [dataSource]="dataSource"
    [fields]="mapping"
    [enabled]="!disabled && !fG.controls[fCN].disabled"
    [placeholder]="placeholder"
    [allowFiltering]="allowFiltering"
    [sortOrder]="sortOrder"
    [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '')"
    (change)="onChange($event)"
    (close)="onClose()"
    (open)="checkEndOfList($event)"
    (filtering)="filter($event)">
    <!-- the valueTemplate shows the selected option when the dropdown is closed -->
    <ng-template #valueTemplate let-data="">
      @if (resolveDisplayItem(data); as displayItem) {
      <div class="d-flex align-items-center">
        @if (icon) {
          <app-icon-badge [style]="'plainIcon'" [icon]="icon"></app-icon-badge>
        }
        @if (getItemVisual(displayItem); as vis) {
          @if (vis.kind === 'image') {
            <app-avatar [type]="'xxs'" [image]="vis.value"></app-avatar>
          }
          @if (vis.kind === 'icon') {
            <app-icon-badge [style]="'plainIcon'" [icon]="vis.value"></app-icon-badge>
          }
        }

        <span class='custom-value text-muted truncate-text-one-line'>{{ displayItem ? displayItem.name : placeholder}}</span>
      </div>
      }
    </ng-template>
    <!-- the itemTemplate shows the defines how the dropdown elements will look like when the dropdown is opened  -->
    <ng-template #itemTemplate let-data="">
      <div class="d-flex align-items-center indentfix px-1">
        @if (getItemVisual(data); as vis) {
          @if (vis.kind === 'image') {
            <app-avatar [type]="'xxs'" [image]="vis.value"></app-avatar>
          }
          @if (vis.kind === 'icon') {
            <app-icon-badge [style]="'plainIcon'" [icon]="vis.value"></app-icon-badge>
          }
        }
        <span class="{{ (marker === 'priority' && data.id === 'high') ? 'text-danger' : (marker === 'priority' && data.id === 'medium') ? 'text-warning' : (marker === 'priority' && data.id === 'low') ? 'text-success' : '' }}">{{data.name}}</span>
      </div>
    </ng-template>
  </ejs-dropdownlist>

  @if (hasErrorField) {
    <div class="error-label" role="alert">
      {{ errorText && fG.controls[fCN].invalid && fG.controls[fCN].dirty ? errorText : '' }}
    </div>
  }
</form>
